import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { SystemSecuritySettingsState, SetSystemSecurityPayload } from "Interfaces";

const initialState: SystemSecuritySettingsState = {
	autoLogout: false,
	autoLogoutDuration: 1
};

const setSystemSecuritySettingsReducer = (
	state: SystemSecuritySettingsState,
	action: PayloadAction<SetSystemSecurityPayload>
) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

const getSystemSecuritySettings = (state: SystemSecuritySettingsState) => {
	return state;
};

const systemSecuritySlice = createAppSlice({
	name: "security",
	initialState,
	reducers: {
		setSystemSecuritySettingsAction: setSystemSecuritySettingsReducer
	},
	selectors: {
		selectSystemSecuritySettings: getSystemSecuritySettings
	}
});

export default systemSecuritySlice;

export const { setSystemSecuritySettingsAction } = systemSecuritySlice.actions;
export const { selectSystemSecuritySettings } = systemSecuritySlice.selectors;
